/* i18n */
import { useI18n } from 'vue-i18n'

/* Assets and Helpers */
import { amountFormat } from '@/assets/scripts/amounts'
import { removeMinLengthFromRegex } from '@/assets/scripts/strings'
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'

/* Parser for Agent Unitel Info */
export const agentUnitelInfoParser = (formData, accountsBalances) => {
	const { t } = useI18n()

	/* Client's Data */
     const clientData = {
        label: t('payments.unitel.step2.clientDataDivider'),
        icon: 'profile',
        lines: [{
            label: t('payments.unitel.step2.agentNumberLabel'),
            content: formData.agentNumber
        },
        {
            label: t('payments.unitel.step2.agentNameLabel'),
            content: formData.agentName
        }]
    }
    /* Origin Account */
    const originAccountBlock = {
        label: t('payments.unitel.step2.originAccountDivider'),
        icon: 'accounts',
        lines: [{
            label: t('payments.unitel.step2.originAccountLabel'),
            content: accountsBalances.find(account => account.id === formData.originAccount).accountNumber,
            mask: ACCOUNT_NUMBER
        }]
    }
    /* Payment Details */
    const paymentDetailsBlock = {
        label: t('payments.unitel.step2.paymentDetailsDivider'),
        icon: 'payment',
        lines: [{
            label: t('payments.unitel.step2.amountLabel'),
            content: amountFormat(formData.amount, formData.currency)
        }]
    }

    return [clientData, originAccountBlock, paymentDetailsBlock]
}

/**
* Receives MDW generic field (Array), and parse it to be ready to use in v-for of InputGeneric or InputAmount
@fields { Array }
@return { Array } - fields modified
*/
export const parseMDWFields = (fields, labelText, maxLength, placeholder) => {
	return fields.reduce((acc, field) => {
        let componentType = 'input-generic'
        let ourMask

		switch (field.type) {
			/* Formatting user */
			case 'USER':
				if (field.style === 'SIMPLE') {
                    if (field.validator) {
                        ourMask = {
                            regex: removeMinLengthFromRegex(field.validator),
                            validatorFn: (string, regex) => {
                                const regExp = new RegExp(regex)
                                return regExp.test(string)
                            }
                        }
                    }

                    componentType = 'input-generic'
                }

                if (field.style === 'MONEY') componentType = 'input-amount'
				break
            case 'USER_SPECIFIED':
                componentType = 'input-amount'
                break
			/* No formating */
            case 'FIXED':
			default:
				componentType = 'text-block-generic'
		}

		acc.push({
			...field,
            field: field.param,
            componentType: componentType,
			params: {
                labelText: labelText || field.label,
                placeholder: placeholder || field.placeholder,
                errorState: false,
                errorMessage: null,
                mandatory: true,
                maxLength: maxLength,
                ourMask: ourMask,
                applyNumbersIntInputMode: field.param === 'reference'
            }
		})

        /* Filter acc to not render the 'id' */
        const renderOnlyInputs = acc.filter(field => field.field !== 'id' || (field.field === 'id' && field.type === 'USER'))
		return renderOnlyInputs
	}, [])
}

/**
* Receives form data fields (Object) and selected payment fields (Object),
and parse it to be one object with the corrects keys and values to help us populate our form data
@formData { Object }
@selectedPayment { Object }
@getAccountsBalances { Array }
@return { Object } - fields modified
*/
export const parseSelectedPaymentData = (formData, selectedPayment, getAccountsBalances) => {
    const data = {}

    for (const field in formData) {
        for (const key in selectedPayment) {
            if (field === key) data[field] = selectedPayment[field]

            if (selectedPayment.dstvCustomerNumber) data.customerNumber = selectedPayment.dstvCustomerNumber
            if (selectedPayment.dstvDeviceNumber) data.deviceNumber = selectedPayment.dstvDeviceNumber
            if (selectedPayment.accountId) data.originAccount = selectedPayment.accountId
            if (selectedPayment.originAccountNumber && !selectedPayment.accountId) {
                const accountId = getAccountsBalances.find(account => account.accountNumber === selectedPayment.originAccountNumber).id
                data.originAccount = accountId
            }
            if (selectedPayment.product) data.productId = selectedPayment.product.code
            if (selectedPayment.productDetail) data.valueId = selectedPayment.productDetail.code
        }
    }

    return data
}
